export enum TemplateType {
  AFTERMAEKETING_TEMPLATE = 'AfterMarketing_Template',
  REGULAR_TEMPLATE = 'Regular_Template',
}
